import { orderBy } from 'lodash'

import { useSidebarContext } from './SidebarContext'

export function useSidebarTabs() {
  return orderBy(useSidebarContext(true).tabs, 'weight', 'asc')
}
